import * as React from "react";
import { Context } from "./_context";
export const FlashlightOffFillIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 20a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1l8-6.5V20Zm2-17a1 1 0 0 1 1 1v1.219l2.356-1.984 1.289 1.53-19 16-1.29-1.53L8 14.481V12L5.463 8.956A2 2 0 0 1 5 7.676V4a1 1 0 0 1 1-1h12Z", fill: "currentColor" }));
  return iconset[size];
};
FlashlightOffFillIcon.iconId = "XZ1FZ3";
